import * as React from 'react';
import {
  List,
  Datagrid,
  DateField,
  TextField,
  DeleteButton,
  NumberField,
  ImageField,
  TextInput,
  ShowButton,
  EditButton,
  BooleanField,
  useTranslate,
} from 'react-admin';
import { TelegramProductBulkActions } from './TelegramProductBulkActions';

export const TelegramProductList: React.FC = () => {
  const translate = useTranslate();

  return (
    <List filters={[<TextInput key="q" source="q" label={translate('app.common.searchByTitle')} alwaysOn />]}>
      <Datagrid rowClick="show" bulkActionButtons={<TelegramProductBulkActions />}>
        <TextField source="id" />
        <TextField source="title" />
        <TextField source="size" sortable={false} />
        <TextField
          source="description"
          sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}
        />
        <NumberField source="price" />
        <ImageField
          source="image"
          title="title"
          sortable={false}
          sx={{ '& img': { maxWidth: 100, maxHeight: 100, objectFit: 'contain' } }}
        />
        <DateField source="createdAt" />
        <BooleanField source="postedInTg" label={translate('app.telegram.inTg')} />
        <ShowButton />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};
